import React from 'react';
import { Tabs, Tab, Box } from '@mui/material';

const AccountsNavBarComponent = ({ value, onChange, isMobile }) => {
  // console.debug('isMobile', isMobile);

  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: '100%',
        borderBottom: '1px solid #C0C0C0',
        overflowX: 'hidden',
      }}
    >
      <Tabs
        value={value}
        onChange={onChange}
        aria-label="navigation tabs"
        centered={!isMobile}
        variant={isMobile ? 'scrollable' : 'fullWidth'}
        scrollButtons={false}
        textColor="inherit"
        TabIndicatorProps={{
          sx: { backgroundColor: '#C7CB00', height: 2, zIndex: 1 },
        }}
        sx={{
          position: 'relative',
          zIndex: 1,
          width: '100%',
          maxWidth: '100%',
          minHeight: isMobile ? 40 : 48,
          '& .MuiTabs-flexContainer': {
            gap: isMobile ? 0.25 : 0,
          },
          '& .MuiTabs-scroller': {
            overflowX: isMobile ? 'auto !important' : 'visible',
          },
        }}
      >
        {['My Details', 'Drivers', 'Vehicles', 'Properties', 'Pets'].map(
          (label, index) => (
            <Tab
              key={label}
              label={label}
              sx={{
                fontSize: isMobile ? '0.7rem' : '1rem',
                fontWeight: 700,
                color: value === index ? '#1C2F3A' : '#B3B3B3',
                textTransform: 'none',
                minWidth: isMobile ? 'auto' : 0,
                px: isMobile ? 1 : 0,
                minHeight: isMobile ? 40 : 48,
              }}
            />
          )
        )}
      </Tabs>
    </Box>
  );
};

export default AccountsNavBarComponent;
